import { IMapping } from './model/IMapping';
import { IMappingCreate } from './model/IMappingCreate';
import { IMappingUpdate } from './model/IMappingUpdate';
import { create, get, remove, update } from './Provider';

const RESOURCE = 'public/mappings';

export const Mapping = {
  create: async (mapping: IMappingCreate): Promise<string> => (await create(RESOURCE, mapping)).json(),
  update: (mapping: IMappingUpdate) => update(RESOURCE, mapping),
  delete: (id: string) => remove(RESOURCE, id),
  get: (id: string) => get<IMapping>(RESOURCE, id)
}